<template>
  <tr class="mortgage-row-component">
    <td v-if="getTableColumnValues.includes('customer')">
      <BadgeComponent v-if="hasCustomer" :customer="mortgage.customer.data"></BadgeComponent>
    </td>
    <td v-if="getTableColumnValues.includes('hypotheeknummer')">
      <a v-if="hasUri" :href="mortgage.uri" v-on:click.stop title="Hypotheek bekijken">
        {{ mortgage.hypotheeknummer || '-' }}
      </a>
      <span v-else>
        {{ mortgage.hypotheeknummer || '-' }}
      </span>
    </td>
    <td v-if="getTableColumnValues.includes('mortgage_properties')">
      <p v-for="(property, index) in addresses" :style="{'margin-bottom': index === addresses.length -1 ? 0 : ''}">
        {{ property.street }} {{ property.number }}{{ property.number_letter }}{{ property.number_addition }}<br>
        {{ property.postal_code }} {{ property.city }}
      </p>
    </td>
    <td v-if="getTableColumnValues.includes('passeerdatum')">
      {{ mortgage.passeerdatum | toDate }}
    </td>
    <td v-if="getTableColumnValues.includes('marktwaarde')">
      {{ mortgage.marktwaarde | toCurrency(0) }}
    </td>
    <td v-if="getTableColumnValues.includes('agency_name')">
      {{ mortgage.agency_name }}
    </td>
    <td v-if="getTableColumnValues.includes('company_label_description')">
      {{ mortgage.company_label_description }}
    </td>
    <td v-if="getTableColumnValues.includes('hypotheciareInschrijving')">
      {{ mortgage.hypotheciareInschrijving | toCurrency(0) }}
    </td>
    <td v-if="getTableColumnValues.includes('principal_sum')">
      {{ mortgage.principal_sum | toCurrency(0) }}
    </td>
    <td v-if="getTableColumnValues.includes('remaining_principal_sum')">
      {{ mortgage.remaining_principal_sum | toCurrency(0) }}
    </td>
    <td v-if="getTableColumnValues.includes('remaining_interest_only_sum')">
      {{ mortgage.remaining_interest_only_sum | toCurrency(0) }}
    </td>
    <td v-if="getTableColumnValues.includes('end_financing_reservation_date')">
      {{ mortgage.end_financing_reservation_date | toDate }}
    </td>
    <td v-if="getTableColumnValues.includes('bank_guarantee_date')">
      {{ mortgage.bank_guarantee_date | toDate }}
    </td>
    <td v-if="getTableColumnValues.includes('validity_unsigned_offer_date')">
      {{ mortgage.validity_unsigned_offer_date | toDate }}
    </td>
    <td v-if="getTableColumnValues.includes('validity_signed_offer_date')">
      {{ mortgage.validity_signed_offer_date | toDate }}
    </td>
    <td v-if="getTableColumnValues.includes('final_offer_date')">
      <!-- Offerte ongetekend geldig tot -->
      {{ mortgage.final_offer_date | toDate }}
    </td>
    <td v-if="getTableColumnValues.includes('offer_expire_date')">
      <!-- Offerte getekend geldig tot -->
      {{ mortgage.offer_expire_date | toDate }}
    </td>
    <td v-if="getTableColumnValues.includes('quotation_extend_date')">
      <!-- Geldigheidsduur offerte te verlengen tot -->
      {{ mortgage.quotation_extend_date | toDate }}
    </td>
  </tr>
</template>

<script>
import BadgeComponent from "~/modules/customer/components/BadgeComponent";
import UserBadgeComponent from "~/modules/user/components/BadgeComponent";
import EmailStatusComponent from "~/modules/email/components/EmailStatusComponent";
import TaskBadgeGroupComponent from "~/modules/task/components/TaskBadgeGroupComponent";
import DateFormatEnum from '~/enums/DateFormatEnum';
import TaskStatus from "~/enums/TaskStatusEnum";

const moment = require("moment");

export default {
  name: "MortgageRowComponent",
  props: {
    mortgage: {
      type: Object,
      required: true
    },
    tableColumns: {
      type: Array,
      required: true
    }
  },
  components: {
    BadgeComponent,
    UserBadgeComponent,
    EmailStatusComponent,
    TaskBadgeGroupComponent
  },
  computed: {
    addresses() {
      return this.mortgage.mortgage_properties.data.map(mortgageProperty => {
        const property = mortgageProperty.property.data;

        let numberLetter = property.number_letter ? ` ${property.number_letter}` : '';
        let numberAddition = property.number_addition ? ` ${property.number_addition}` : '';

        return {
          street: property.street,
          number: property.number,
          number_letter: numberLetter,
          number_addition: numberAddition,
          postal_code: property.postal_code.toUpperCase(),
          city: property.city ? property.city.charAt(0).toUpperCase() + property.city.slice(1) : ''
        };
      });
    },
    hasCustomer() {
      return typeof this.mortgage.customer_id !== "undefined"
          && this.mortgage.customer_id !== null
          && typeof this.mortgage.customer !== "undefined"
          && this.mortgage.customer !== null
          && this.mortgage.customer.data !== null;
    },
    getTableColumnValues() {
      return this.tableColumns.map(column => column.value)
    },
    hasUri() {
      return typeof this.mortgage.uri !== "undefined"
          && this.mortgage.uri !== null
          && this.mortgage.uri !== '#';
    }
  }
};
</script>

<style scoped>
tr td.half-padding {
  padding: 4px;
}

tr.selected {
  background-color: #1890ff1c;
}

table th.compact, table td.compact {
  white-space: nowrap;
  width: 1px !important;
}

tr .pencil-icon {
  display: none;
}

tr:hover .pencil-icon {
  display: initial;
}
</style>
